import { Directive, ElementRef, HostListener, Inject, Input, AfterViewInit, Renderer2 } from '@angular/core';
import { APP_CONTEXT_TOKEN } from '@core/context';

@Directive({
    selector: 'img[backgroundImage], mb-carousel[backgroundImage]',
    standalone: true
})
export class BackgroundImageDirective implements AfterViewInit {
  @Input() backgroundImage: boolean = false;

  private readonly DEFAULT_IMAGE_AVANTRIP = '/hotels/dist/es-AR/browser/assets/images/avantrip-hotel-no-image.svg';
  private readonly DEFAULT_IMAGE_ALMUNDO = '/hotels/dist/es-AR/browser/assets/images/almundo-hotel-no-image.svg';

  constructor(
    private elRef: ElementRef,
    private renderer: Renderer2,
    @Inject(APP_CONTEXT_TOKEN) private context: any
  ) {}

  ngAfterViewInit() {
    const element = this.elRef.nativeElement as HTMLElement;
    if (element.tagName.toLowerCase() === 'mb-carousel') {
      this.applyFallbackToCarousel();
    }
  }

  @HostListener('error')
  onImageError() {
    const element: HTMLImageElement = this.elRef.nativeElement;
    element.src = this.getDefaultImage();
    this.renderer.addClass(element, 'has-fallback-bg');

  }

  @HostListener('load')
  onImageLoad() {
    const element: HTMLImageElement = this.elRef.nativeElement;
    if (this.backgroundImage) {
      element.parentElement.className = 'gallery-item hover-gallery';
    }
  }

  private applyFallbackToCarousel() {
    const images: NodeListOf<HTMLImageElement> = this.elRef.nativeElement.querySelectorAll('img');
    images.forEach((img) => {
      img.onerror = () => {
        img.src = this.getDefaultImage()
        this.renderer.addClass(img, 'has-fallback-bg');
      }
    });

    const observer = new MutationObserver(() => {
      const imgs = this.elRef.nativeElement.querySelectorAll('img');
      imgs.forEach((img) => {
        if (!img.onerror) {
          img.onerror = () => {
            img.src = this.getDefaultImage()
            this.renderer.addClass(img, 'has-fallback-bg');
          }
        }
      });
    });

    observer.observe(this.elRef.nativeElement, {
      childList: true,
      subtree: true,
    });
  }

  private getDefaultImage(): string {
    return this.context.brand === 'avantrip'
      ? this.DEFAULT_IMAGE_AVANTRIP
      : this.DEFAULT_IMAGE_ALMUNDO;
  }
}
